import React from 'react';
import Icon from '@ant-design/icons';
import { config } from './config';

export default function view({ type }) {
  return <Icon component={config[type]} />;
}
